export function ConversationsEntrypoint() {
  // Intentionally blank. This component is only loaded to allow us to React navigate
  // to files when in the conversations tab.
  return <></>
}

try{ ConversationsEntrypoint.displayName ||= 'ConversationsEntrypoint' } catch {}